import { c as _c } from "react/compiler-runtime";
import { List } from '@mui/material';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { OptionItem } from './OptionItem';
type Props<T extends string> = {
  options: {
    label: T;
    count: number;
  }[];
  selectedOptionsSet: Set<T>;
  onOptionSelect: (option: T) => void;
  onClose: () => void;
};
function OptionsListInner(t0) {
  const $ = _c(18);
  const {
    options,
    selectedOptionsSet,
    onOptionSelect,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const optionRefs = useRef(t1);
  const [focusedIndex, setFocusedIndex] = useState(0);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      setFocusedIndex(index);
      optionRefs.current[index]?.focus({
        preventScroll: true
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const focusOption = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      focusOption(0);
    };
    t4 = [focusOption];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== focusedIndex || $[5] !== onClose || $[6] !== onOptionSelect || $[7] !== options) {
    t5 = e => {
      e.preventDefault();
      if (e.key === "ArrowDown") {
        const nextIndex = (focusedIndex + 1) % options.length;
        focusOption(nextIndex);
      } else {
        if (e.key === "ArrowUp") {
          const prevIndex = (focusedIndex - 1 + options.length) % options.length;
          focusOption(prevIndex);
        } else {
          if (e.key === "Home") {
            focusOption(0);
          } else {
            if (e.key === "End") {
              focusOption(options.length - 1);
            } else {
              if (e.key === " " || e.key === "Enter") {
                const focusedOption = options[focusedIndex];
                onOptionSelect(focusedOption.label);
              } else {
                if (e.key === "Escape" || e.key === "Tab") {
                  onClose();
                }
              }
            }
          }
        }
      }
    };
    $[4] = focusedIndex;
    $[5] = onClose;
    $[6] = onOptionSelect;
    $[7] = options;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleKeyDown = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      p: 0
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== focusedIndex || $[11] !== onOptionSelect || $[12] !== options || $[13] !== selectedOptionsSet) {
    t7 = options.map((option, i) => <OptionItem key={option.label} ref={el => {
      optionRefs.current[i] = el;
    }} option={option} isSelected={selectedOptionsSet.has(option.label)} onSelect={() => onOptionSelect(option.label)} tabIndex={i === focusedIndex ? 0 : -1} />);
    $[10] = focusedIndex;
    $[11] = onOptionSelect;
    $[12] = options;
    $[13] = selectedOptionsSet;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleKeyDown || $[16] !== t7) {
    t8 = <List sx={t6} role="presentation" onKeyDown={handleKeyDown}>{t7}</List>;
    $[15] = handleKeyDown;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export const OptionsList = memo(OptionsListInner) as typeof OptionsListInner;